import { FaPhoneAlt } from "react-icons/fa";
import { BsEnvelope } from "react-icons/bs";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { FaLocationDot } from "react-icons/fa6";
import { ImFacebook2 } from "react-icons/im";
import { FaCalendarAlt } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5";
import { MdSupportAgent } from "react-icons/md";

import GoogleMapComponent from "../components/GoogleMapComponent";
import ContactForm from "../components/ContactForm";
import React from "react";
import { ContactData } from "../data-types/api-client/api-contacts";
interface ContactProps {
  contact: ContactData | undefined; // Accept ContactData as a prop
}

const Contact: React.FC<ContactProps> = ({ contact }) => {
  if (!contact) {
    return null; // Handle null contact state
  }

  return (
    <div className="flex w-full justify-self-center 2xl:w-3/4 text-custom-atrament bg-custom-white items-center justify-center rounded-lg">
      <div className="flex flex-col md:px-20 sm:px-8 px-4 lg:gap-8 lg:flex-row w-full mb-8">
        <div className="flex flex-col self-stretch lg:w-1/2 w-full">
          {" "}
          <div className="w-full py-4 rounded-t-lg">
            <div className="flex flex-col w-full rounded-2xl">
              <div className="flex items-center justify-center gap-3 py-2">
                <div className="flex p-3 items-center justify-center rounded-full border border-custom-blue-600/40 bg-custom-white text-custom-white">
                  <MdSupportAgent className="text-3xl text-custom-blue-600" />
                </div>
                <h2 className="sm:text-3xl uppercase text-2xl text-center md:text-left text-custom-blue font-bold">
                  Sme tu pre vás
                </h2>
              </div>
              <div className="flex flex-col py-4 rounded-lg gap-4 py-4">
                {" "}
                <div className="flex w-full items-start justify-center">
                  <div className="rounded-xl w-full bg-custom-blue-100 p-5 border border-custom-blue/10">
                    <div className="mb-4 flex items-center gap-4">
                      <div className="flex p-3 items-center justify-center rounded-full bg-custom-blue-600 text-custom-white">
                        <FaCalendarAlt className="text-xl" />
                      </div>

                      <div>
                        <h3 className="sm:text-lg lg:text-base text-base font-bold text-custom-blue">
                          Rezervácie a poradenstvo
                        </h3>
                        <p className="text-sm text-custom-blue/70">
                          Overte si dostupnosť zariadení a rezervujte si ich
                          vopred.
                        </p>
                      </div>
                    </div>

                    <a
                      href={`tel:${contact?.contact.mobileConsultancy}`}
                      className="flex items-center justify-center gap-3 rounded-xl bg-custom-white p-3 text-base font-bold shadow-md transition hover:scale-[1.02]"
                    >
                      <FaPhoneAlt className="text-custom-blue-600" />
                      {contact?.contact.mobileConsultancy}{" "}
                    </a>
                  </div>
                </div>
                <div className="flex flex-col gap-4 xl:flex-row sm:flex-row lg:flex-col">
                  {" "}
                  <a
                    href={`mailto:${contact?.contact.email}`}
                    className="
    group
    w-full 
    md:flex-[2]
    rounded-lg
    py-3
    bg-custom-white
    border
    border-custom-blue/10
    px-4
    flex
    justify-start
    items-center
    gap-3
    cursor-pointer
    no-underline
    transition-all
    hover:border-custom-blue/30
    hover:shadow-md
  "
                  >
                    <BsEnvelope className="text-xl text-custom-atrament transition-colors group-hover:text-custom-blue" />

                    <span className="font-semibold">
                      {contact?.contact.email}
                    </span>

                    <IoIosArrowForward className="w-5 h-auto md:w-5 md:h-5 text-custom-blue ml-auto transition-transform" />
                  </a>
                  <a
                    href={`${contact?.contact.facebookUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="
    group
    w-full 
    md:flex-[1]
    flex
    py-3
    rounded-lg
    bg-custom-white
    border
    border-custom-blue/10
    px-4
    justify-start
    items-center
    gap-3
    cursor-pointer
    no-underline
    transition-all
    hover:border-custom-blue/30
    hover:shadow-md
  "
                  >
                    <ImFacebook2 className="text-xl transition-colors group-hover:text-custom-blue" />

                    <span className="flex items-center">Facebook</span>

                    <IoIosArrowForward
                      className="w-5
 h-auto md:w-5 md:h-5 text-custom-blue ml-auto transition-transform"
                    />
                  </a>
                </div>
              </div>
              <div className="flex flex-col items-center pb-6 bg-custom-white rounded-lg shadow-md">
                {/* <div className="flex w-full flex-col bg-custom-white gap-1 lg:p-6 py-6 justify-center lg:items-start items-center">
                  {" "}
                  <div className="flex justify-start items-center gap-3">
                    {" "}
                    <FaLocationDot className="text-custom-red lg:text-4xl text-3xl" />
                    <h2
                      className="uppercase sm:text-xl text-base tracking-wider text-center md:text-left text-custom-blue font-
                            bold"
                    >
                      Výdajné miesto
                    </h2>
                  </div>
                  <p className="font-bold xl:text-5xl text-custom-blue lg:text-4xl sm:text-5xl text-3xl">
                    {contact?.contact.address.dispensingPoint}
                  </p>
                  <div className="flex justify-center items-center w-full">
                    {" "}
                    <p
                      className="font-normal text-custom-blue/75
                             text-lg text-center tracking-wider"
                    >
                      {contact?.contact.address.dispensingPointDetails}
                    </p>
                  </div>
                </div> */}
                <div className="flex w-full flex-col bg-custom-white rounded-lg gap-1 lg:px-4 pt-8 pb-4 justify-center lg:items-start items-center">
                  {" "}
                  <div className="flex justify-start items-center gap-2">
                    {" "}
                    <FaLocationDot className="text-custom-red lg:text-4xl text-3xl" />
                    <h2
                      className="uppercase sm:text-xl text-base tracking-wider text-center md:text-left text-custom-blue font-
                              bold"
                    >
                      Výdajné miesto
                    </h2>
                  </div>
                  <div className="flex justify-center flex-col lg:pl-10 lg:items-start items-center w-full">
                    <p className="font-bold xl:text-5xl text-custom-blue lg:text-4xl sm:text-5xl text-3xl">
                      {contact?.contact.address.dispensingPoint}
                    </p>{" "}
                    <p
                      className="font-normal text-custom-blue/75
                               text-lg text-center tracking-wider"
                    >
                      {contact?.contact.address.dispensingPointDetails}
                    </p>
                  </div>
                </div>
                <div className="flex justify-center w-full bg-custom-white h-[15rem]">
                  {" "}
                  <GoogleMapComponent contact={contact} />
                </div>
              </div>{" "}
            </div>
          </div>
          <div className="flex flex-col lg:rounded-b-lg gap-4 w-full pt-4">
            <div className="flex flex-col w-full px-4 bg-bg-light rounded-lg pb-6 pt-2">
              {" "}
              <div className="flex justify-start items-center gap-3 py-2 w-full">
                {" "}
                <h2 className="uppercase text-base text-center md:text-left text-custom-blue font-bold">
                  Adresa{" "}
                </h2>
              </div>
              <div className="flex bg-custom-white flex-col md:flex-row md:gap-0 gap-3 shadow-sm rounded-xl justify-center items-start py-2 md:px-4 w-full">
                {" "}
                <div className="flex md:justify-center rounded-lg justify-start items-center py-2 md:w-1/2 w-full">
                  <div className="flex w-full flex-col items-start text-left gap-5">
                    <div className="flex gap-2 justify-start items-center rounded-xl md:rounded-none px-4 w-full">
                      {" "}
                      <div className="flex px-1">
                        <HiOutlineBuildingOffice2 className="text-custom-blue text-xl" />
                      </div>
                      <p className="font-semibold text-custom-blue uppercase text-sm md:text-base lg:text-sm xl:text-base">
                        {contact?.contact.address.name}
                      </p>
                    </div>

                    <div className="flex gap-2 justify-start items-center rounded-xl md:rounded-none px-4 w-full">
                      <div className="flex px-1">
                        {" "}
                        <FaLocationDot className="text-custom-atrament text-xl" />
                      </div>

                      <p className="text-sm md:text-base lg:text-sm xl:text-base">
                        {" "}
                        {`${contact?.contact.address.street} ${contact?.contact.address.number}, ${contact?.contact.address.psc} ${contact?.contact.address.village}`}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex md:justify-center justify-start items-center py-2 md:w-1/2 w-full">
                  <div className="flex w-full flex-col items-start text-left gap-4">
                    <div className="flex gap-2 justify-start items-center md:p-0 px-4 w-full">
                      <div className="flex px-1">
                        <IoDocumentTextOutline className="text-xl text-custom-atrament/70" />
                      </div>
                      <p className="text-sm md:text-base lg:text-sm xl:text-base">
                        IČO: {contact?.contact.ico}
                      </p>
                    </div>

                    <div className="flex gap-2 justify-start items-center md:p-0 px-4 w-full">
                      <div className="flex px-1">
                        <IoDocumentTextOutline className="text-xl text-custom-atrament/70" />
                      </div>
                      <p className="text-sm md:text-base lg:text-sm xl:text-base">
                        DIČ: {contact?.contact.dic}
                      </p>
                    </div>

                    <div className="flex gap-2 justify-start items-center md:p-0 px-4 w-full">
                      <div className="flex px-1">
                        <IoDocumentTextOutline className="text-xl text-custom-atrament/70" />
                      </div>
                      <p className="text-sm md:text-base lg:text-sm xl:text-base">
                        IČ DPH: {contact?.contact.icdph}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>{" "}
        <div className="flex lg:w-1/2 w-full lg:pt-2 mt-8 lg:mt-0 lg:pb-0 sm:bg-custom-white lg:rounded-lg self-stretch shadow-sm justify-center items-center">
          {" "}
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;
